import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";

export const HighlightViewSeparator = () => (
  <Typography.LabelXs weight="medium">{t("separator_dot")}</Typography.LabelXs>
);
